import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import RenderIcons from "../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../store";
import * as ConfigurationActions from "../store/configurationService/actions";

type ForgotPasswordConfirmProps = RouteComponentProps<{}>;

const ForgotPasswordConfirm: React.FunctionComponent<ForgotPasswordConfirmProps> = (props) => {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <main id="l-page-content" aria-labelledby="title-page">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                Reset Password
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className="box box-has-shadow box-sm offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">Reset Password</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>Thank you! An email has been sent with instructions to get your new password.</p>
                                    </div>
                                </div>

                                <div className="box-content">
                                    <div className="form-row">
                                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => props.history.push("/")}>
                                            <span className="btn-text">Back to Login</span>
                                        </button>
                                    </div>

                                    <div className="line-divider margin-vertical-l"></div>

                                    <h2 className="content-sub-title">Need Help?</h2>
                                    <p>
                                        <a href="contact-us.html" className="default_link">
                                            Contact Us
                                        </a>{" "}
                                        if you forgot your User ID (Email).
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </React.Fragment>
    );
};

export default ForgotPasswordConfirm;
